import { getNavMenuContent } from '@hhgtech/hhg-components'
import {
  cleanUpUndefined,
  formatCategory,
  formatCommunity,
  formatExpertUser,
  formatHealthToolTypeCategory,
} from 'api/dataTransform'
import { PATHS } from 'api/paths'
import { callApi, getApiPath, getTogetherPath } from 'api/utils'
import Component from 'container/categories/category/ExpertDetail.Page'
import { useGetIsMobile, useScreenSize } from 'hooks'
import { IExpertDetailPage } from 'interfaces/categories.interface'
import { CategoryHealthToolApi } from 'interfaces/types'
import { GetServerSideProps } from 'next'
import { ROLE_USER_REGEX } from 'utils/contains'

const AuthorPage = (props: IExpertDetailPage) => {
  const { isMobileSsr } = props
  const { isMobile: isMobileCsr } = useScreenSize()

  const isMobile = useGetIsMobile(isMobileSsr, isMobileCsr)

  const componentProp: IExpertDetailPage = {
    side: 'author',
    isMobile,
    ...props,
  }
  return <Component {...componentProp} />
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { query } = ctx
  const { slug } = query

  const finalSlug = Array.isArray(slug) ? slug[slug.length - 1] : slug

  const [
    expertRes,
    categoriesApi,
    healthToolsDataByCategories,
    togetherCommunitiesRes,
    footer,
    navMenuContent,
  ] = await Promise.all([
    callApi(
      getApiPath(PATHS.GET_USER_INFO, {
        slug: finalSlug || '',
      }),
      'get',
    ),
    callApi(getApiPath(PATHS.GET_ALL_CATEGORIES), 'GET'),
    callApi(getApiPath(PATHS.GET_HEALTH_TOOLS_BY_CATEGORY), 'GET'),
    callApi(getTogetherPath(PATHS.GET_TOGETHER_COMMUNITY), 'GET'),
    callApi(getApiPath(PATHS.GET_DYNAMIC_FOOTER), 'GET'),
    getNavMenuContent('vi-VN_MB'),
  ])

  if (expertRes && expertRes.status === 2 && expertRes.data?.redirect_url) {
    return {
      redirect: {
        destination: expertRes.data.redirect_url,
        permanent: true,
      },
    }
  }

  if (
    !expertRes ||
    expertRes.status !== 1 ||
    expertRes?.data?.turn_off_profile
  ) {
    return {
      notFound: true,
    }
  }

  const profileSlug = expertRes?.data?.profile_url || ''

  if (
    // ROLE_USER['1'].includes(profileSlug) &&
    ROLE_USER_REGEX[1].test(profileSlug) &&
    profileSlug
  ) {
    return {
      redirect: {
        destination: profileSlug,
        permanent: true,
      },
    }
  }

  return {
    props: {
      expert: formatExpertUser(expertRes.data),
      categories: categoriesApi?.data?.map(formatCategory) ?? [],
      healthTools:
        (healthToolsDataByCategories?.data &&
          healthToolsDataByCategories?.data.length > 0 &&
          healthToolsDataByCategories?.data?.map(
            (category: CategoryHealthToolApi) =>
              formatHealthToolTypeCategory(category),
          )) ||
        [],
      togetherCommunities: togetherCommunitiesRes?.data?.communities
        ? togetherCommunitiesRes.data.communities.map(formatCommunity)
        : [],
      footerMenu: footer?.data ?? {},
      dataNavMenuContent: cleanUpUndefined(navMenuContent) || null,
    },
  }
}

export default AuthorPage
